import React, { FC, ReactNode } from 'react';
import classNames from 'classnames';

import { Container, Row, Column } from '../grid/Grid';

import styles from './content_header.module.scss';

type Props = {
  topComponent?: ReactNode;
  title: ReactNode;
  subComponent?: ReactNode;
};

export const ContentHeader: FC<Props> = ({
  title,
  topComponent,
  subComponent,
}) => {
  return (
    <div className={styles.background}>
      <Container className={styles.content}>
        {topComponent && (
          <Row className={styles.topComponentContainer}>
            <Column>{topComponent}</Column>
          </Row>
        )}
        <Row>
          <Column>
            <h1
              className={classNames(styles.title, {
                [styles.withoutSubComponent]: !subComponent,
              })}
            >
              {title}
            </h1>
          </Column>
        </Row>
        {subComponent && (
          <Row>
            <Column>{subComponent}</Column>
          </Row>
        )}
      </Container>
    </div>
  );
};
